import { BeneficiaryCountry, Currency, LegalEntityCountry } from '@seapoint/server/enums';

type GetIsAddressRequiredArgs = {
  beneficiaryCountry: BeneficiaryCountry;
  companyCountry: LegalEntityCountry;
  currency: Currency;
};

export const getIsAddressRequired = ({ beneficiaryCountry, companyCountry, currency }: GetIsAddressRequiredArgs) => {
  const isNonGbpCurrency = currency !== Currency.GBP;
  const isDifferentJurisdictions =
    (beneficiaryCountry === BeneficiaryCountry.GB) !== (companyCountry === LegalEntityCountry.GB);

  return isNonGbpCurrency && isDifferentJurisdictions;
};
